import PropTypes from 'prop-types';
import React from 'react';
import { ohiToUpdateIs } from '../../utils/helpers';

const ohiAlert = (
  <va-alert status="info" class="vads-u-margin-bottom--4">
    <h2 slot="headline" className="vads-u-font-size--h3">
      You’ll need to submit another form later
    </h2>
    <div>
      <p className="vads-u-margin-top--0">
        Since you need to update your other non-VA health insurance information,
        you’ll need to submit a CHAMPVA Other Health Insurance Certification (VA
        Form 10-7959c).
      </p>
      <p>
        We’ll guide you to this additional form after you complete this one.
      </p>
    </div>
  </va-alert>
);

const SupplementalInformationDescription = ({ formData }) => (
  <>
    {ohiToUpdateIs('both')(formData) && ohiAlert}
    <p>
      Now we’ll ask you a few questions so we make sure to update the CHAMPVA
      application or enrollment information for the correct person.
    </p>
    <p>
      After we confirm some details, you can upload your supporting documents.
    </p>
  </>
);

SupplementalInformationDescription.propTypes = {
  formData: PropTypes.shape({
    'view:ohiToUpdate': PropTypes.string,
  }),
};

export default SupplementalInformationDescription;
